
const user = {
    info: {
        user_id: null,
        user_full_name: null,
        master_user_id: null,
        timezone_name: null,
        email: null,
        org_id: null,
        org_name: null
    },
    permissions: []
};

loadUserInfo();

function loadUserInfo() {
    try {
        const storedInfo = JSON.parse(atob(sessionStorage.getItem('user'))) || {};
        Object.assign(user, storedInfo);
    } catch (e) {}
}

function getUser() {
    return user;
}

function hasAccess(permission) {
    return user.permissions.includes(permission);
}

function getUserTimezone() {
    return user.info.timezone_name || Intl.DateTimeFormat().resolvedOptions().timeZone || null;
}

export { getUser, hasAccess, getUserTimezone };